import { render, staticRenderFns } from "./RsaPazienteHomePage.vue?vue&type=template&id=1f1902e1"
import script from "./RsaPazienteHomePage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteHomePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports